import type { TMessages } from '@/types/TMessages'

export const messages = {
  appMobileAuthButton: 'Зарегистрироваться',
} satisfies TMessages
